<template>
  <div>

    <div class="headerWrapper">
      <i class="icon iconfont"
        @click="showMenu">&#xe62b;</i>
      {{title}}
      <!-- <i class="icon iconfont">&#xe630;</i> -->
    </div>

    <div :class="['left-menu',{'exchange-menu-next':!isShowExchangeMenu}]">
      <div :class="{'checked-menu':checkedMenu==index}"
        class="menu-content-wrapper"
        v-for="(item,index) in menuData"
        :key="index"
        @click="link(index,item.title)">
        <div class="img-wrapper">
          <img :src="item.titleIcon"
            :alt="item.title">
        </div>
        <span>{{item.title}}</span>

      </div>
    </div>
    <div class="exchange-menu-right" v-if="isShowExchangeMenu" v-tap @tap="hiddenExchange"></div>

    <div>
      <div class="one-title"
        ref="oneTitle"
        v-if="title!='主力合约'">
        <span v-tap
          @tap="title1Link(index,item)"
          :class="{'title1-active':checkedTitle1Text==item.productName}"
          v-for="(item,index) in  _.uniqBy(contractData,'productId')"
          :key="index"
          v-if="item.exchangeName == currentExchangeName">{{item.productName}}</span>

      </div>
      <div class="two-title"
        :class="{'two-title2':title=='主力合约'}">
        <span v-for="(item,index) in titleData2"
          :key="index">{{item}}</span>
      </div>

      <ul class="order_content"
        :class="{'order_content2':title=='主力合约'}">
        <li
          @click="linkDeatil(item)"
          v-for="(item,index) in contentData"
          :key="index"
          v-if="title!='主力合约'">
          <span class="targetId">{{item.targetId}}</span>
          <span :class="{ 'latestPrice-up':Number(item.latestPrice)>Number(item.lastSettlementPrice),
                          'latestPrice-down':Number(item.latestPrice)<Number(item.lastSettlementPrice)}">{{item.latestPrice}}</span>
          <span>{{item.volume}}</span>
          <span>
            <i @click="changeShowData"
              :class="[ 'li-three-span', { 'background-grey':Number(item.latestPrice)==Number(item.lastSettlementPrice),
                        'background-red':Number(item.latestPrice) > Number(item.lastSettlementPrice),
                        'background-green':Number(item.latestPrice) < Number(item.lastSettlementPrice)}]">
                        {{percent?
                        ((Number(item.latestPrice)-Number(item.lastSettlementPrice))*100/Number(item.lastSettlementPrice)).toFixed(2)+'%':
                        (Number(item.latestPrice)-Number(item.lastSettlementPrice) > 0?'+' + (Number(item.latestPrice)-Number(item.lastSettlementPrice)).toFixed(0):
                        (Number(item.latestPrice)-Number(item.lastSettlementPrice)).toFixed(0))}}</i>
          </span>
        </li>

        <li
          @click="linkDeatil(item)"
          v-for="(item,index) in _.orderBy(contentData2, ['exchangeId','targetId'], ['desc','desc'])"
          :key="index"
          v-if="title=='主力合约'">
          <span class="targetId">{{getTargetId(item)}}</span>
          <span :class="{ 'latestPrice-up':Number(item.latestPrice)>Number(item.lastSettlementPrice),
                          'latestPrice-down':Number(item.latestPrice)<Number(item.lastSettlementPrice)}">{{item.latestPrice}}</span>
          <span>{{item.volume}}</span>

          <span>
            <i @click="changeShowData"
              :class="{ 'background-grey':Number(item.latestPrice)==Number(item.lastSettlementPrice),
                        'background-red':Number(item.latestPrice)>Number(item.lastSettlementPrice),
                        'background-green':Number(item.latestPrice)<Number(item.lastSettlementPrice)}"
              class="li-three-span"> {{percent?
                                      ((Number(item.latestPrice)-Number(item.lastSettlementPrice))*100/Number(item.lastSettlementPrice)).toFixed(2)+'%':
                                      (Number(item.latestPrice)-Number(item.lastSettlementPrice) > 0?'+' + (Number(item.latestPrice)-Number(item.lastSettlementPrice)).toFixed(0):
                                      (Number(item.latestPrice)-Number(item.lastSettlementPrice)).toFixed(0))}}</i>
          </span>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import yjheader from "@/components/common/yjheader";
import shangqi from "@/assets/images/market/shangqi.png";
import dashuang from "@/assets/images/market/dashuang.png";
import zhenshuang from "@/assets/images/market/zhenshuang.png";
import zhongjin from "@/assets/images/market/zhongjin.png";
import nengyuan from "@/assets/images/market/nengyuan.png";
import guangqi from "@/assets/images/market/guangqi.png";
import zhuli from "@/assets/images/market/zhuli.png";
import front from "../../../static/js/proto/CtpFront.js";
import model from "../../../static/js/proto/Model.js";
import art from "../../../static/js/proto/art/Art.js";
import tmi from "../../../static/js/proto/tmi/Tmi.js";
import * as _ from "lodash";

export default {
  name: "market",
  components: {
    yjheader
  },
  data() {
    return {
      name: "market",
      currentExchangeName: "上期所",
      currentProductId: "",
      lastProductId: "",
      contentDataSeconds: [],
      title: "上期所",
      menuData: [
        {
          title: "上期所",
          titleIcon: shangqi,
          link: "shfe"
        },
        {
          title: "大商所",
          titleIcon: dashuang,
          link: "shfe"
        },
        {
          title: "郑商所",
          titleIcon: zhenshuang,
          link: "shfe"
        },
        {
          title: "中金所",
          titleIcon: zhongjin,
          link: "shfe"
        },
        {
          title: "能源中心",
          titleIcon: nengyuan,
          link: "nengyuan"
        },
        {
          title: "广期所",
          titleIcon: guangqi,
          link: "shfe"
        },
        {
          title: "主力合约",
          titleIcon: zhuli,
          link: "zhuli"
        }
      ],
      titleData1: [
        "黄金",
        "石油沥青",
        "沪铜",
        "燃油",
        "热轧卷板",
        "沪铅",
        "螺纹钢",
        "像胶",
        "线材",
        "沪锌",
        "像胶",
        "线材"
      ],
      titleData2: ["合约", "最新价", "成交量", "涨跌幅"],
      contentData: [],
      checkedMenu: 0,
      // checkedTitle1: 0,
      checkedTitle1Text: "",
      percent: true,
      contractData: [],
      contentData2: [],
      mainList: [],
      dominant_view: "dominant_view",
      isShowExchangeMenu: false,         // 是否“显示交易所导航菜单”
    };
  },
  computed: {},
  watch: {
    currentProductId(curVal, oldVal) {
      if (curVal == "") {
        return;
      }
      this.subTick(curVal);
    }
  },
  mounted() {
    this.contractData = front.targetList;
    this.link(0, this.title);
    this.checkedTitle1Text = "沪银";
    // this.checkedTitle1 = "";
    this.title = "上期所";
  },
  beforeDestroy() {},

  // 进入行情页面
  activated() {
    this.$store.commit("selectIndex", 1);
    front.autoMount(art.bind(this, this.load));
  },

  // 切出行情页面
  deactivated() {
    front.unsubTick(this.currentProductId, this.name);
    this.domiantUnsub();
    beferFooterIndex = 1;
  },

  methods: {
    getTargetId(item) {
      // return item.targetName.length <= 8 ? item.targetName : item.targetId;
      return item.targetName;
    },
    // 初始化页面数据：用于切入页面与恢复页面数据。
    load(onFail) {
      this.contractData = front.targetList;
      if (this.checkedMenu == 6) {
        this.domiantSub();
      } else {
        this.subTick(this.currentProductId);
      }
    },

    // 主力合约订阅与反订阅
    domiantSub() {
      var subTick = targetId =>
        front.subTick(targetId, {
          suberId: this.dominant_view,
          publish: tick => this.onDominantTick(tick)
        });
      if (!model.dominantSet) {
        model.dominantSet = front.dominantTargetSub({
          suberId: this.dominant_view,
          publish: target => subTick(target.targetId)
        });
      } else {
        _.forEach(Object.keys(model.dominantSet), subTick);
      }
    },
    domiantUnsub() {
      if (model.dominantSet) {
        _.forEach(Object.keys(model.dominantSet), targetId =>
          front.unsubTick(targetId, this.dominant_view)
        );
      }
    },

    // 主力合约行情信息
    onDominantTick(tick) {
      var that = this;
      if (tick.targetId === undefined) {
        return;
      }
      const target = front.targetSet[tick.targetId];
      if (target === undefined) return;

      // #.查找主力合约是否存在
      var productId = tmi.productId(tick.targetId);
      const find = _(that.contentData2).findIndex(
        r => r.productId == productId
      );
      // 1.添加主力合约
      if (find === -1) {
        var data = {};
        Object.assign(data, tick);
        data.productId = productId;
        data.targetName = target.targetName;
        that.contentData2.push(data);
        return;
      }

      // 2.更新主力合约
      var oldTargetId = that.contentData2[find].targetId;
      Object.assign(that.contentData2[find], tick);
      that.contentData2[find].targetName = target.targetName;
      // 取消订阅被替换的主力合约
      if (tick.targetId != oldTargetId) {
        front.unsubTick(oldTargetId, that.dominant_view);
      }
    },

    // 订阅品种的行情信息
    subTick(productId) {
      var that = this;
      that.contentData = [];
      for (var i = 0; i < that.contractData.length; ++i) {
        var elem = that.contractData[i];
        if (elem.productId == productId) {
          that.contentData.push({
            targetId: elem.targetId,
            lastSettlementPrice: 1,
            latestPrice: 1,
            volume: 0
          });
        }
      }
      if (that.lastProductId !== that.currentTargetId) {
        // 订阅合约品种
        front.subTick(productId, {
          suberId: "market",
          publish: function(tick) {
            for (var i = 0; i < that.contentData.length; ++i) {
              var elem = that.contentData[i];
              if (elem.targetId == tick.targetId) {
                elem.lastSettlementPrice = tick.lastSettlementPrice;
                elem.latestPrice = tick.latestPrice;
                elem.volume = tick.volume;
                elem.askPrice1 = tick.askPrice1;
                elem.bidPrice1 = tick.bidPrice1;
                elem.highPrice = tick.highPrice;
                elem.highStopPrice = tick.highStopPrice;
                elem.lastClosePrice = tick.lastClosePrice;
                elem.lowPrice = tick.lowPrice;
                elem.lowStopPrice = tick.lowStopPrice;
                elem.openPrice = tick.openPrice;
                elem.bidVolume1 = tick.bidVolume1;
                elem.askVolume1 = tick.askVolume1;
                elem.position = tick.position;
                that.contentData[i] = elem;
              }
            }
          }
        });
        // 取消订阅切换前的品种
        if (that.lastProductId !== productId) {
          front.unsubTick(that.lastProductId, this.name);
        }
      }
      that.lastProductId = productId;
    },

    link(i, title) {
      this.checkedMenu = i;
      this.title = title;
      if (i == 0) {
        this.currentExchangeName = "上期所";
        this.currentProductId = "ag";
        this.checkedTitle1Text = "沪银";
        this.domiantUnsub();
      } else if (i == 1) {
        this.currentExchangeName = "大商所";
        this.currentProductId = "a";
        this.checkedTitle1Text = "豆一";
        this.domiantUnsub();
      } else if (i == 2) {
        this.currentExchangeName = "郑商所";
        this.currentProductId = "AP";
        this.checkedTitle1Text = "苹果";
        this.domiantUnsub();
      } else if (i == 3) {
        this.currentExchangeName = "中金所";
        this.currentProductId = "IC";
        this.checkedTitle1Text = "中证500";
        this.domiantUnsub();
      } else if (i == 4) {
        this.currentExchangeName = "上期能源";
        this.currentProductId = "sc";
        this.checkedTitle1Text = "原油";
        this.domiantUnsub();
      } else if (i == 5) {
        this.currentExchangeName = "广期所";
        this.currentProductId = "si";
        this.checkedTitle1Text = "工业硅";
        this.domiantUnsub();
      } else if (i == 6) {
        this.domiantSub();
      }
      this.isShowExchangeMenu = false;
    },
    // 点击隐藏交易所选项
    hiddenExchange() {
      this.isShowExchangeMenu = false;
    },
    showMenu() {
      this.isShowExchangeMenu = !this.isShowExchangeMenu;
      // window.scrollTo(0,0);
      if (this.title !== "主力合约") {
        this.$refs.oneTitle.scrollTo(0, 0); //this.$refs.input1  减少获取dom节点的消耗
      }
    },
    title1Link(index, item) {
      if (item.productId == this.currentProductId) {
        return;
      }
      // this.$toast(11);
      this.currentProductId = item.productId;
      this.checkedTitle1Text =item.productName;
      // this.checkedTitle1 = index;
      // this.$toast(index);
      // prompt('输入你的名字：', '默认名字');
    },
    changeShowData(e) {
      e.stopPropagation();
      this.percent = !this.percent;
      if (this.percent == true) {
        this.titleData2[3] = "涨跌幅";
      } else if (this.percent == false) {
        this.titleData2[3] = "涨跌";
      }
    },
    unique(arr, key, obj) {
      const res = new Map();
      return arr.filter(key => !res.has(key) && res.push(obj));
    },
    linkDeatil(item) {
      this.$router.push({ path: "/marketDetail/" + item.targetId });
      // this.$router.push({path:'/marketDeatil'});
    }
  }
};
</script>

<style scoped>
.iconfont {
  font-family: "iconfont" !important;
  font-size: 0.36rem;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  padding: 0 0.2rem;
  color: #fff;
  float: left;
}

.headerWrapper {
  /*text-align: center;*/
  /*background: #7D2029;*/
  background: #1c201f;
  color: #fff;
  font-size: 0.36rem;
  vertical-align: center;
  height: 1rem;
  line-height: 1rem;
  /* display: flex; */
  /* justify-content: space-between; */
  /* flex-direction: row; */
  text-align: center;

  /* 限制为单行，以免影响下一列的显示 @huang.z.d 20231212 */
  /* white-space: nowrap;*/ /*这会阻止文本换行，并将其限制为单行 */
  overflow: hidden; /* 这会隐藏文本溢出的部分 */
  /* text-overflow: ellipsis; */ /*这会在文本溢出时显示省略号*/
}

.left-menu {
  background: #2c3e50;
  color: #fff;
  font-size: 0.24rem;
  width: 49%;
  display: inline-block;
  position: fixed;
  top: 1rem;
  left: 0;
  bottom: 1.1rem;

  z-index: 2000;
  overflow-y: auto;
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
  transition: all 0.3s;
}
.exchange-menu-next {
  left: -51%
}
.exchange-menu-right {
  width: 51%;
  display: inline-block;
  position: fixed;
  top: 1rem;
  right: 0;
  bottom: 1.1rem;
  z-index: 2000;
}

.right-wrapper {
  display: inline-block;
  /*float:left;*/
}

.checked-menu {
  background: #7d7d7d;
}

.menu-right {
  /*margin-left: 50%;*/
  position: absolute;
  left: 50%;
  width: 50%;
  overflow: hidden;
}

.background-grey {
  background: #a0a0a0;
}

.background-red {
  background: #ff0000;
}

.background-green {
  background: #008000;
}

.title1-active {
  /*padding-bottom: 0.19rem;*/
  /*display: inline-block;*/
  /*padding-bottom: 0.2rem;*/
  /*!*border-bottom: 2px solid #ff0100;*!*/
  /*border-bottom: 2px solid deeppink;*/
  /*background: deeppink;*/
  color: #ff0100;
  /*color: orange;*/
}

.menu-content-wrapper {
  height: 1rem;
  padding: 0.36rem 0;
  display: flex;
  justify-content: center;
  flex-direction: row;
}

.img-wrapper {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  padding-right: 0.3rem;
  margin-left: -0.3rem;
  display: inline-block;
}

.img-wrapper img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.menu-content-wrapper span {
  color: #fff;
  font-size: 0.35rem;
  display: inline-block;
  height: 1rem;
  text-align: center;
  line-height: 1rem;
  /*vertical-align: center;*/
  /*padding-top: 0.2rem;*/
}

.one-title {
  height: 1rem;
  /*display: flex;*/
  /*justify-content:space-around;*/
  /*flex-direction: row;*/
  color: #fff;
  font-size: 0.32rem;
  width: auto;
  overflow: scroll;
  white-space: nowrap;
  line-height: 1rem;
  /*border-bottom: 1px solid #ddd7ce;*/
  /*background: #1F1F1F;*/
  /*background: #3e3a3a;*/
  /*background: #08142D;*/
  background: #161712;
  /* -webkit-overflow-scrolling: touch; */
  overflow-x: scroll;
}

.one-title::-webkit-scrollbar {
  display: none;
  opacity: 0;
}

.one-title span {
  margin: 0 0.25rem;
}

.two-title {
  /*width: 7.5rem;*/
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.3rem;
  color: #f5f9fc;
  background: #1f1f1f;
  display: flex;
  justify-content: center;
  flex-direction: row;
  /*position: relative;*/
}

/*.two-title::before{*/

/*content: "  ";*/
/*position: absolute;*/
/*left: 0;*/
/*top: 0;*/
/*width: 100%;*/
/*height: 1px;*/
/*background-color: #fff;*/
/*!*background-color: #202228;*!*/
/*!* 如果不用 background-color, 使用 border-top:1px solid #e0e0e0; *!*/
/*-webkit-transform: scaleY(.5);*/
/*transform:scaleY(.5);*/

/*}*/

.two-title span {
  width: 25%;
  display: inline-block;
  text-align: center;
}
/* 加大“合约”字段的宽度 */
.two-title span:nth-child(1)
{
  width: 35%;
}

ul {
  width: 7.5rem;
  background: #1f1f1f;
}

li {
  line-height: 1rem;
  height: 1rem;
  display: flex;
  justify-content: center;
  flex-direction: row;
  font-size: 0.3rem;
  color: #a0a4a7;
  /*border-bottom: 1px solid #dedede;*/
  /*font-weight: bold;*/
  position: relative;
}

li::after {
  content: "  ";
  position: absolute;
  left: 0;
  top: 1rem;
  width: 100%;
  height: 1px;
  background-color: #444;
  /*background-color: #202228;*/
  /* 如果不用 background-color, 使用 border-top:1px solid #e0e0e0; */
  -webkit-transform: scaleY(0.1);
  transform: scaleY(0.1);
}

li span {
  display: inline-block;
  width: 25%;
  text-align: center;
  overflow: hidden;
  /*overflow: scroll;*/
}

/* 加大“合约”字段的宽度 */
li span:nth-child(1)
{
  width:35%;
}

.li-three-span {
  border-radius: 3px;
  height: 0.6rem;
  text-align: center;
  display: inline-block;
  font-style: normal;
  line-height: 0.6rem;
  width: 85%;
  color: #fff;
}
.order_content {
  width: 100%;
  position: absolute;
  top: 3rem;
  bottom: 1rem;
  overflow: scroll;
  /* -webkit-overflow-scrolling: touch; */

  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}
.order_content2 {
  top: 2rem;
}

.two-title2 {
  background: #161712;
}
.targetId {
  color: #d8b830;
  /*color:#A57518;*/
}

.latestPrice-up {
  /*color:#DE071D;*/
  color: #ff0000;
}

.latestPrice-down {
  /*color:#23D51F;*/
  color: #008000;
}
</style>



// WEBPACK FOOTER //
// src/components/yj/market.vue